import React, { useEffect, useState } from "react";
import Layout from "../../common/layout";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Container } from "../../common/layout/styels";
import { MenuGroupItem } from "../settings/styels";
import { useNavigate } from "react-router-dom";
import { AddButton } from "../../../elements/list/styles";
import { AddIcon } from "../../../../icons";
import { useDispatch } from "react-redux";
import LegalDocumentList from "./LegalDocumentList";
import { deleteData, getData, postData, putData } from "../../../../backend/api";

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  padding: 2rem 0;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const LeftColumn = styled.div`
  flex: 2;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin: 20px;
`;

const Heading2 = styled.h3`
  margin: 0;
  color: #222;
`;

const SubHeading = styled.h3`
  margin-bottom: 1rem;
  margin-top: 0;
  font-weight: 700;
`;

const Paragraph = styled.p`
  margin: 0;
  line-height: 1.6;
`;

const LEGAL_TYPES = {
  DATA_PRIVACY: "DATA_PRIVACY",
  WHISTLEBLOWER_INFO: "WHISTLEBLOWER_INFO",
};

const DataPrivacy = ({setLoaderBox, setMessage}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [privacyDocs, setPrivacyDocs] = useState([]);
  const [whistleDocs, setWhistleDocs] = useState([]);

  const fetchData = async () => {
    setLoaderBox(true);
    const [privacy, whistle] = await Promise.all([
      getLegalDocuments(LEGAL_TYPES.DATA_PRIVACY),
      getLegalDocuments(LEGAL_TYPES.WHISTLEBLOWER_INFO),
    ]);

    setPrivacyDocs(privacy.data.data);
    setWhistleDocs(whistle.data.data);
    setLoaderBox(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleUpload = async (type, e) => {
    const file = e.target.files[0];
    if (!file) return;
    setLoaderBox(true);
    await uploadLegalDocument(type, file);
    fetchData();
  };

  const getLegalDocuments = async (type) => {
    try {
        const response = await getData({type}, "legal-document", dispatch, navigate);
        if (response.status === 200 && response.data) {
            return response;
        }
    } catch (error) {
        console.error("Error fetching legal documents:", error);
    }
  }

  const uploadLegalDocument = async (type, file) => {
    try {
        const payload = {type, name: file.name, file};
        const response = await postData(payload, "legal-document", dispatch, navigate);
        if (response.status === 200 && response.data) {
           
        }
    } catch (error) {
        console.error("Error fetching legal documents:", error);
    }
  }

  const activateLegalDocument = async (id) => {
    try {
        setLoaderBox(true);
        const response = await putData({isActive: true}, `legal-document/${id}`, dispatch, navigate);
        if (response.status === 200 && response.data) {
           fetchData();
        }
    } catch (error) {
        console.error("Error fetching legal documents:", error);
    } finally {
        setLoaderBox(false);
    }
  }

  const deleteLegalDocument = async (id) => {
    try {
        setLoaderBox(true);
        const response = await deleteData({}, `legal-document/${id}`, dispatch, navigate);
        if (response.status === 200 && response.data) {
           fetchData();
        }
    } catch (error) {
        console.error("Error fetching legal documents:", error);
    } finally {
        setLoaderBox(false);
    }
  }

  return (
    <Container className="noshadow column" style={{padding: '0'}}>
    
        <LeftColumn>
          <Heading2>{t("Data Privacy Statement")} & {t("Whistleblower Information")}</Heading2>

        <Wrapper>

          <MenuGroupItem className="support">
            <SubHeading>{t("Data Privacy Statement")}</SubHeading>
            <Paragraph>{t("dataPrivacyStatementDescription")}</Paragraph>
            <AddButton as="label" style={{ margin: "20px 0", width: 'fit-content', padding: '0 1em' }}>
                <AddIcon fontSize={18} color="#fff" />
                <span>{t("selectFile")}</span>
                <input
                    type="file"
                    hidden
                    accept="application/pdf"
                    onChange={(e) => handleUpload(LEGAL_TYPES.DATA_PRIVACY, e)}
                />
            </AddButton>

            <Paragraph>{t("List with the file to activate, deactivate, and delete.")}</Paragraph>
            <LegalDocumentList
                data={privacyDocs}
                onActivate={activateLegalDocument}
                onDelete={deleteLegalDocument}
                t={t}
            />
          </MenuGroupItem>

          <MenuGroupItem className="support">
            <SubHeading>{t("Whistleblower Information")}</SubHeading>
            <Paragraph>{t("whistleblowerInformationDescription")}</Paragraph>
            <AddButton as="label" style={{ margin: "20px 0", width: 'fit-content', padding: '0 1em' }}>
                <AddIcon fontSize={18} color="#fff" />
                <span>{t("selectFile")}</span>
                <input
                    type="file"
                    hidden
                    accept="application/pdf"
                    onChange={(e) => handleUpload(LEGAL_TYPES.WHISTLEBLOWER_INFO, e)}
                />
            </AddButton>

            <Paragraph>{t("List with the file to activate, deactivate, and delete.")}</Paragraph>
            <LegalDocumentList
                data={whistleDocs}
                onActivate={activateLegalDocument}
                onDelete={deleteLegalDocument}
                t={t}
            />
          </MenuGroupItem>

        </Wrapper>

        </LeftColumn>

    </Container>
  );
};

export default Layout(DataPrivacy);
